<template>
  <div class="input-wrap-holder">
    <div class="input-col calender">
      <label class="label-text">{{ label }}</label>
      <div class="input-hold date">
        <flat-pickr :locale="$i18n.locale" class="form-control" v-model="value[dateProp]" :config="config"></flat-pickr>
      </div>
    </div>

    <div class="input-col" v-if="time">
      <label class="label-text font-style">{{ $t('general.time') }}</label>
      <div class="input-hold time">
        <select class="form-control" v-model="value[timeProp]">
          <option :selected="time === time" v-for="(time, key) in timeMins" :key="key">{{ time }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import times from "@/utils/timeOptions"

export default {
  name: "input-date-time",
  components: {
    flatPickr,
  },
  props: {
    label: { type: String, default: 'Date & Time', required: true },
    minDate: { default: 'today' },
    dateProp: { default: 'A' },
    timeProp: { default: 'A' },
    time: { default: true },
    wrapper: { default: true },
    value: { 
      type: Object,
      default() {
        return { 
          time: null,
          date: null,
        };
      },
    },
  },
  watch: {
    minDate(value) {
      this.config.minDate = value ? value : 'today';

      if(value > this.value[this.dateProp]) {
        this.value[this.dateProp] = value;
      }
    },
  },
  mounted() {
    this.config.minDate = this.minDate;
    this.windowSize();
    window.addEventListener("resize", this.windowSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowSize);
  },
  methods: {
    windowSize() {
      this.config.showMonths = document.documentElement.clientWidth < 600 ? 1 : 2;
    },
  },
  data() {
    return {
      config: {
        dateFormat: 'Y-m-d',
        altFormat: 'D, d/m/y',
        altInput: true,
        minDate: "today",
        showMonths: 1,
        disableMobile: "true",
        monthSelectorType: "static",
        locale: {
          firstDayOfWeek: 1
        }
      }, 
      timeMins: times
    };
  },
};
</script>